import * as actionTypes from "../actionTypes/Index";
import {customersInitialState} from "./InitialState";
import {IActionType} from "../../interfaces/Index";

const initialState = { ...customersInitialState };

export const appendUpdateCustomers = (payload: any, state: any) => {
  if (payload.isPaginatedRes) {
    return [...state.customers, ...payload.customerData];
  }
  return payload.customerData.slice();
};

export default function customerReducer(
  state = initialState,
  action: IActionType
) {
  switch (action.type) {
    case actionTypes.CREATE_CUSTOMERS_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        isCustomerAdded: false,
        error: null,
      });
    }
    case actionTypes.CREATE_CUSTOMERS_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isCustomerAdded: true,
      });
    }
    case actionTypes.CREATE_CUSTOMERS_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        isCustomerAdded: false,
        error: action.error,
      });
    }
    case actionTypes.GET_CUSTOMERS_INIT: {
      return Object.assign({}, state, {
        isFetchCustomerLoading: true,
        isFetchCustomerError: false,
        isCustomerUpdated: false,
        isCustomerAdded: false,
        error: null,
      });
    }
    case actionTypes.GET_CUSTOMERS_SUCCESS: {
      return Object.assign({}, state, {
        isFetchCustomerLoading: false,
        // customers: (action.payload! as any).customerData.slice(),
        customers: appendUpdateCustomers(action.payload, state),
        pagination: (action.payload! as any).pagination,
      });
    }
    case actionTypes.GET_CUSTOMERS_FAIL: {
      return Object.assign({}, state, {
        isFetchCustomerLoading: false,
        isFetchCustomerError: true,
        error: action.error,
      });
    }
    case actionTypes.GET_CUSTOMER_DETAIL_V2_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        iscustomerDetailsNewFetched: false,
        customerDetailsNew: null,
        error: null,
      });
    }
    case actionTypes.GET_CUSTOMER_DETAIL_V2_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: false,
        iscustomerDetailsNewFetched: true,
        // meta: (action.payload! as Array<any>).slice(),
        customerDetailsNew: action.payload,
      });
    }
    case actionTypes.GET_CUSTOMER_DETAIL_V2_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        iscustomerDetailsNewFetched: false,
        error: action.error,
      });
    }
    case actionTypes.CLEAR_DETAIL_V2_DATA: {
      return Object.assign({}, state, {
        customerDetailsNew: null,
      });
    }

    case actionTypes.GET_BULK_CUSTOMER_DETAIL_V2_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        isBulkCustomerDetailsFetched: false,
        bulkCustomerDetails: null,
        error: null,
      });
    }

    case actionTypes.GET_BULK_CUSTOMER_DETAIL_V2_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: false,
        isBulkCustomerDetailsFetched: true,
        bulkCustomerDetails: action.payload,
      });
    }
    case actionTypes.GET_BULK_CUSTOMER_DETAIL_V2_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        isBulkCustomerDetailsFetched: false,
        error: action.error,
      });
    }
    case actionTypes.CLEAR_BULK_CUSTOMER_DETAIL_V2_DATA: {
      return Object.assign({}, state, {
        bulkCustomerDetails: null,
      });
    }
    case actionTypes.UPDATE_CUSTOMERS_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        isCustomerUpdated: false,
        error: null,
      });
    }
    case actionTypes.UPDATE_CUSTOMERS_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isCustomerUpdated: true,
        meta: [],
      });
    }
    case actionTypes.UPDATE_CUSTOMERS_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        isCustomerUpdated: false,
        error: action.error,
      });
    }
    case actionTypes.GET_STORE_TYPE_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        error: null,
        storeType: [],
      });
    }
    case actionTypes.GET_STORE_TYPE_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        error: null,
        isError: false,
        storeType: action.payload,
      });
    }
    case actionTypes.GET_STORE_TYPE_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        error: action.error,
        storeType: [],
        isError: true,
      });
    }
    case actionTypes.FETCH_CUSTOMER_CONFIG_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        error: null,
        customerConfig: []
      });
    }
    case actionTypes.FETCH_CUSTOMER_CONFIG_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: false,
        customerConfig: action.payload
      });
    }
    case actionTypes.FETCH_CUSTOMER_CONFIG_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        error: action.error,
        customerConfig: []
      });
    }
    case actionTypes.GET_CUSTOMER_ZONE_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        error: null,
        customerZones: {},
      });
    }
    case actionTypes.GET_CUSTOMER_ZONE_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        error: null,
        isError: false,
        customerZones: action.payload,
      });
    }
    case actionTypes.GET_CUSTOMER_ZONE_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        error: action.error,
        customerZones: {},
        isError: true,
      });
    }
    default:
      return state;
  }
}
